import React from "react";
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";

import moment from "moment";

import { Link } from "react-router-dom";

import { InfoOutlined } from "@material-ui/icons";

import { WebTracker } from "../types";

import { CheckMarkIcon } from "../../components/icons/themes/materialdesign";
import { theme } from "../../theme";

import useWTMURLs from "../useWTMURLs";

export type BlockedTrackersTableRow = {
  webTracker: WebTracker;
  isPublished: boolean;
  numPages: number | null;
  lastDetectedAt: Date | null;
};

export type BlockedTrackersTableProps = {
  rows: BlockedTrackersTableRow[];
};

function BlockedTrackersTable({ rows }: BlockedTrackersTableProps) {
  const wtmURLs = useWTMURLs();

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>
              <Typography variant="h6">Tracking tool</Typography>
            </TableCell>

            <TableCell align="center">
              <Typography variant="h6">Published?</Typography>
            </TableCell>

            <TableCell align="center">
              <Typography variant="h6">Pages detected</Typography>
            </TableCell>

            <TableCell align="center">
              <Typography variant="h6">Last detected</Typography>
            </TableCell>

            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => {
            return (
              <TableRow
                key={`blocked-trackers-table-row-${row.webTracker.name}`}
              >
                <TableCell>
                  <Link to={wtmURLs.urlForTrackerDetail(row.webTracker)}>
                    {row.webTracker.name}
                  </Link>
                </TableCell>

                <TableCell align="center">
                  {row.isPublished ? (
                    <CheckMarkIcon color={theme.palette.success.main} />
                  ) : (
                    <InfoOutlined style={{ color: theme.palette.error.main }} />
                  )}
                </TableCell>

                <TableCell align="center">
                  <Typography variant="body1">
                    {row.numPages ?? "Unknown"}
                  </Typography>
                </TableCell>

                <TableCell align="center">
                  {row.lastDetectedAt === null ? (
                    <Typography variant="body1">Unknown</Typography>
                  ) : (
                    <Typography variant="body1">
                      {moment(row.lastDetectedAt).fromNow()}
                    </Typography>
                  )}
                </TableCell>

                <TableCell align="right">
                  <Link to={wtmURLs.urlForTrackerDetail(row.webTracker)}>
                    <Button color="primary" size="small" variant="outlined">
                      View Details
                    </Button>
                  </Link>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default BlockedTrackersTable;
